import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { dismissPrivacyNoticeForToday, shouldShowPrivacyNotice } from './privacyNotice';

const PrivacyPolicyNotice = () => {
  const [open, setOpen] = useState(false);
  const [hideToday, setHideToday] = useState(false);

  useEffect(() => {
    setOpen(shouldShowPrivacyNotice(Date.now(), document.cookie));
  }, []);

  const close = () => {
    if (hideToday) dismissPrivacyNoticeForToday();
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby={'privacy-policy-notice-title'}
      PaperProps={{ sx: { width: 520, maxWidth: 'calc(100% - 32px)' } }}
    >
      <DialogTitle id={'privacy-policy-notice-title'}>개인정보처리방침 통합 시행 안내</DialogTitle>
      <DialogContent>
        <Typography variant={'body2'} sx={{ lineHeight: 1.7 }}>
          안녕하세요. 항상 저희 서비스를 이용해 주셔서 감사합니다.
        </Typography>
        <Typography variant={'body2'} sx={{ lineHeight: 1.7, mt: 1.5 }}>
          소중한 개인정보를 더욱 안전하고 체계적으로 보호하기 위해 기존에 각 서비스별로 분산되어
          운영되던 개인정보처리방침을 통합 개인정보처리방침으로 통합하여 변경 시행하게 되었습니다.
        </Typography>
        <Typography variant={'body2'} sx={{ lineHeight: 1.7, mt: 1.5 }}>
          앞으로도 당사는 관련 법령을 철저히 준수하며 개인정보 보호를 위해 최선을 다하겠습니다.
          감사합니다.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between', px: 3, pb: 2 }}>
        <FormControlLabel
          control={
            <Checkbox
              size={'small'}
              checked={hideToday}
              onChange={(event) => setHideToday(event.target.checked)}
            />
          }
          label={'오늘 하루 동안 보지 않기'}
          sx={{ '.MuiFormControlLabel-label': { fontSize: 14 } }}
        />
        <Button variant={'contained'} onClick={close}>
          확인
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrivacyPolicyNotice;
